import { i18n } from "../../translate/i18n";
import { tokensDoTemplate } from "../CampaignModal/TemplateFields";

// Regras puras do bloco de template do agendamento (canal WhatsApp Oficial).
//
// Por que existe: o agendamento dispara quando ninguém está olhando, quase
// sempre FORA da janela de 24h da Meta, onde texto livre não passa. Sem
// template escolhido o backend cai numa heurística automática que entrega o
// texto do usuário dentro de qualquer template com 1 ou 2 variáveis — conteúdo
// diferente do que ele escreveu — ou falha com status ERRO sem explicação na
// tela. Ver backend/src/services/ScheduleServices/TemplateAgendamento.ts.
//
// O contrato é o mesmo da campanha: `templateParams` é um JSON array de string
// na ordem dos tokens do BODY, e os tokens vêm do backend
// (`variaveisTokens`) — nunca recalculados aqui, para não divergir.

export const conexaoEhOficial = (whatsapps, whatsappId) => {
  const conexao = (whatsapps || []).find((w) => w.id === whatsappId);
  return conexao?.channel === "whatsapp_oficial";
};

export const exigeTemplate = ({ canal, ehOficial }) =>
  canal !== "sms" && Boolean(ehOficial);

export const parseTemplateParams = (valor) => {
  if (Array.isArray(valor)) return valor;
  try {
    const lista = JSON.parse(valor || "[]");
    return Array.isArray(lista) ? lista : [];
  } catch {
    return [];
  }
};

export const templateIncompleto = (template, templateParams) => {
  if (!template) return false;
  const tokens = tokensDoTemplate(template);
  return tokens.some((_, indice) => !(templateParams?.[indice] || "").trim());
};

export const payloadTemplate = ({ ehOficial, template, templateParams }) => {
  if (!ehOficial || !template) {
    return { templateName: null, templateParams: null };
  }

  const tokens = tokensDoTemplate(template);

  return {
    templateName: template.shortcode,
    // Corta pelo número de tokens: parâmetro sobrando de um template trocado
    // no meio da edição faria o backend recusar com "espera N e foram
    // informados M".
    templateParams: JSON.stringify(
      tokens.map((_, indice) => templateParams?.[indice] || "")
    ),
  };
};

// Único lugar que decide o que dizer ao usuário sobre o estado do bloco.
export const avisoTemplate = ({ templates, totalAprovados = 0, template }) => {
  if (!templates || templates.length === 0) {
    return {
      severity: "warning",
      text:
        totalAprovados > 0
          ? i18n.t("scheduleModal.template.emptyIneligible", {
              count: totalAprovados,
            })
          : i18n.t("scheduleModal.template.emptySync"),
    };
  }

  if (!template) {
    return {
      severity: "info",
      text: i18n.t("scheduleModal.template.windowHint"),
    };
  }

  return null;
};
